const SystemPreferences = (() => {
  let inputInstances;
  let systemPreferencesData;

  function getCaseNotesView() {
    const frag = document.createDocumentFragment();

    const checkbox = new Checkbox({
      label: 'Enable Voice to Text',
      id: 'EnableVoiceToText',
      'data-section': 'Anywhere',
      'data-key': 'Use_Speech_to_Text_in_Anywhere',
      'data-lookup-key': 'EnableVoiceToText',
      'data-lookup-section': 'CaseNotes',
    });
    checkbox.setValue(systemPreferencesData.CaseNotes.EnableVoiceToText);
    frag.append(checkbox.rootElement);

    inputInstances.CaseNotes = {
      EnableVoiceToText: checkbox,
    };

    return frag;
  }
  function getDayServicesView() {
    const frag = document.createDocumentFragment();

    const checkbox = new Checkbox({
      label: 'Automatically Create Time Entry Records from Day Services',
      id: 'AutoCreateTimeEntryRecordsFromDayServices',
      'data-section': 'Anywhere',
      'data-key': 'Automatic_Entry_for_Single-Entry',
      'data-lookup-key': 'AutoCreateTimeEntryRecordsFromDayServices',
      'data-lookup-section': 'DayServices',
    });
    checkbox.setValue(systemPreferencesData.DayServices.AutoCreateTimeEntryRecordsFromDayServices);
    frag.append(checkbox.rootElement);

    inputInstances.DayServices = {
      AutoCreateTimeEntryRecordsFromDayServices: checkbox,
    };

    return frag;
  }
  function getGeneralView() {
    const frag = document.createDocumentFragment();

    const apiKeyInput = new Input({
      label: 'Azure Api Key',
      id: 'AzureApiKey',
      'data-section': 'Azure_Speech_to_Text',
      'data-key': 'apikey',
      'data-lookup-key': 'AzureApiKey',
      'data-lookup-section': 'General',
    });

    const apiLocationInput = new Input({
      label: 'Azure location',
      id: 'AzureLocation',
      'data-section': 'Azure_Speech_to_Text',
      'data-key': 'Azure_Location',
      'data-lookup-key': 'AzureLocation',
      'data-lookup-section': 'General',
    });

    apiKeyInput.setValue(systemPreferencesData.General.AzureApiKey);
    apiLocationInput.setValue(systemPreferencesData.General.AzureLocation);

    frag.append(apiKeyInput.rootElement);
    frag.append(apiLocationInput.rootElement);

    inputInstances.General = {
      AzureApiKey: apiKeyInput,
      AzureLocation: apiLocationInput,
    };

    return frag;
  }
  function getIncidentTrackingView() {
    const frag = document.createDocumentFragment();

    const keyToValueMap = {
      Automatically_Notify_Supervisors: 'AutoNotifySupervisors',
      Populate_Incident_Date: 'AutoPopulateIncidentDate',
      Populate_Incident_Time: 'AutoPopulateIncidentTime',
      Populate_Reported_Date: 'AutoPopulateReportedDate',
      Populate_Reported_Time: 'AutoPopulateReportedTime',
      Show_Prevention_Plan: 'ShowPreventionPlan',
      Show_Cause_and_Contributing_Factors: 'ShowCauseAndContributingFactors',
      Append_to_Summary_of_Incident: 'AppendToIncidentSummary',
      Append_to_Immediate_Action: 'AppendToImmediateAction',
      Append_to_Prevention_Plan: 'AppendToPreventionPlan',
      'Append_to_Cause_&_Contributing_Factors': 'AppendToCauseAndContributingFactors',
    };

    const checkboxes = {
      Automatically_Notify_Supervisors: 'Automatically Notify Supervisors',
      Populate_Incident_Date: 'Auto-populate Incident Date',
      Populate_Incident_Time: 'Auto-populate Incident Time',
      Populate_Reported_Date: 'Auto-populate Reported Date',
      Populate_Reported_Time: 'Auto-populate Reported Time',
      Show_Prevention_Plan: 'Show Prevention Plan',
      Show_Cause_and_Contributing_Factors: 'Show Cause and Contributing Factors',
      Append_to_Summary_of_Incident: 'Append to Summary of Incident',
      Append_to_Immediate_Action: 'Append to Immediate Action',
      Append_to_Prevention_Plan: 'Append to Prevention Plan',
      'Append_to_Cause_&_Contributing_Factors': 'Append to Cause & Contributing Factors',
    };

    Object.entries(checkboxes).forEach(([key, label]) => {
      const valueKey = keyToValueMap[key];

      const incidentTrackingCheckbox = new Checkbox({
        label,
        id: key,
        'data-section': 'Incident_Tracking',
        'data-key': key,
        'data-lookup-key': valueKey,
        'data-lookup-section': 'IncidentTracking',
      });
      incidentTrackingCheckbox.setValue(systemPreferencesData.IncidentTracking[valueKey]);
      frag.append(incidentTrackingCheckbox.rootElement);

      inputInstances.IncidentTracking = {
        [valueKey]: incidentTrackingCheckbox,
      };
    });

    return frag;
  }
  function getLoginLogoutView() {
    const frag = document.createDocumentFragment();

    const minutesBeforeLogoutInput = new Input({
      type: 'number',
      label: 'Minutes before automatic logout due to inactivity',
      id: 'InactivityLogoutMinutes',
      'data-section': 'Anywhere',
      'data-key': 'Minutes_to_Timeout',
      'data-lookup-key': 'InactivityLogoutMinutes',
      'data-lookup-section': 'LoginLogout',
    });
    // const customLoginTextInput = new Input({
    //   type: 'textarea',
    //   label: 'Custom login text',
    //   id: 'CustomLoginText',
    //   'data-section': 'Anywhere',
    //   'data-key': 'Custom_Login_Text',
    //   'data-lookup-key': 'CustomLoginText',
    //   'data-lookup-section': 'LoginLogout',
    // });
    const twoFactorAuthCheckbox = new Checkbox({
      label: 'Enable two-factor authentication',
      id: 'EnableTwoFactor',
      'data-section': 'Anywhere',
      'data-key': 'Two_factor_authentication',
      'data-lookup-key': 'EnableTwoFactor',
      'data-lookup-section': 'LoginLogout',
    });

    minutesBeforeLogoutInput.setValue(systemPreferencesData.LoginLogout.InactivityLogoutMinutes);
    //customLoginTextInput.setValue(systemPreferencesData.LoginLogout.CustomLoginText);
    twoFactorAuthCheckbox.setValue(systemPreferencesData.LoginLogout.EnableTwoFactor);

    frag.append(minutesBeforeLogoutInput.rootElement);
    //frag.append(customLoginTextInput.rootElement);
    frag.append(twoFactorAuthCheckbox.rootElement);

    inputInstances.LoginLogout = {
      InactivityLogoutMinutes: minutesBeforeLogoutInput,
      //CustomLoginText: customLoginTextInput,
      EnableTwoFactor: twoFactorAuthCheckbox,
    };

    return frag;
  }
  function getPlanView() {
    const frag = document.createDocumentFragment();

    const reportSectionOrderTable = table.build({
      tableId: 'reportSectionOrderTable',
      columnHeadings: ['Section'],
      sortable: true,
      onSortCallback: async ({ newIndex, oldIndex, row }) => {
        const sectionRows = [...reportSectionOrderTable.querySelectorAll('.table__body .table__row')];

        const rowIds = sectionRows.map(row => row.id);

        const resp = await _UTIL.fetchData('updateSystemPreferenceOrder', {
          section: 'Anywhere Plan Report',
          key: '',
          value: rowIds,
        });

        systemPreferencesData.Plan.ReportOrder = [...rowIds];
      },
    });

    table.sortTableByHeader(reportSectionOrderTable);

    const tableData = systemPreferencesData.Plan.ReportOrder.map(section => {
      return {
        id: section,
        values: [section],
      };
    });

    table.populate(reportSectionOrderTable, tableData, true);
    frag.append(reportSectionOrderTable);

    for (let i = 1; i <= 5; i++) {
      const planCheckbox = new Input({
        type: 'text',
        label: `Finalize Plan Email ${i}`,
        id: `FinalizePlanEmail${i}`,
        'data-section': $.session.applicationName === 'Advisor' ? 'Anywhere_Plan' : 'Anywhere',
        'data-key': `Finalize_Plan_Email_${i}`,
        'data-lookup-key': `FinalizePlanEmail${i}`,
        'data-lookup-section': 'Plan',
      });
      planCheckbox.setValue(systemPreferencesData.Plan[`FinalizePlanEmail${i}`]);
      frag.append(planCheckbox.rootElement);

      inputInstances.Plan = {
        [`FinalizePlanEmail${i}`]: planCheckbox,
      };
    }

    return frag;
  }
  function getRosterView() {
    const frag = document.createDocumentFragment();

    const absentFeatureCheckbox = new Checkbox({
      label: 'Use Absent Feature in Anywhere Roster',
      id: 'UseAbsentFeature',
      'data-section': 'Anywhere',
      'data-key': 'Use_Absent_Feature_in_Anywhere_Roster',
      'data-lookup-key': 'UseAbsentFeature',
      'data-lookup-section': 'Roster',
    });
    const progressNotesCheckbox = new Checkbox({
      label: 'Use Progress Notes in Anywhere Roster',
      id: 'UseProgressNotes',
      'data-section': 'Anywhere',
      'data-key': 'Use_Progress_Notes_in_Anywhere_Roster',
      'data-lookup-key': 'UseProgressNotes',
      'data-lookup-section': 'Roster',
    });

    absentFeatureCheckbox.setValue(systemPreferencesData.Roster.UseAbsentFeature);
    progressNotesCheckbox.setValue(systemPreferencesData.Roster.UseProgressNotes);

    frag.append(absentFeatureCheckbox.rootElement);
    frag.append(progressNotesCheckbox.rootElement);

    inputInstances.Roster = {
      UseAbsentFeature: absentFeatureCheckbox,
      UseProgressNotes: progressNotesCheckbox,
    };

    return frag;
  }
  function getSchedulingView() {
    const frag = document.createDocumentFragment();

    const openShiftsCheckbox = new Checkbox({
      label: 'Allow staff to claim open shifts',
      id: 'AllowStaffToClaimOpenShifts',
      'data-section': 'Anywhere_Scheduling',
      'data-key': 'Allow_Users_to_Request_Open_Shifts',
      'data-lookup-key': 'AllowStaffToClaimOpenShifts',
      'data-lookup-section': 'Scheduling',
    });
    const callOffRequestsCheckbox = new Checkbox({
      label: 'Allow staff to send call off requests',
      id: 'AllowStaffToSendCallOffRequests',
      'data-section': 'Anywhere_Scheduling',
      'data-key': 'Allow_Users_to_Send_Call_Off_Requests',
      'data-lookup-key': 'AllowStaffToSendCallOffRequests',
      'data-lookup-section': 'Scheduling',
    });

    openShiftsCheckbox.setValue(systemPreferencesData.Scheduling.AllowStaffToClaimOpenShifts);
    callOffRequestsCheckbox.setValue(systemPreferencesData.Scheduling.AllowStaffToSendCallOffRequests);

    frag.append(openShiftsCheckbox.rootElement);
    frag.append(callOffRequestsCheckbox.rootElement);

    inputInstances.Scheduling = {
      AllowStaffToClaimOpenShifts: openShiftsCheckbox,
      AllowStaffToSendCallOffRequests: callOffRequestsCheckbox,
    };

    return frag;
  }
  function getTimeEntryView() {
    const frag = document.createDocumentFragment();

    const keyToValueMap = {
      Any_Note_Required: 'NoteRequired',
      Any_Odometer_Required: 'OdometerRequired',
      Any_License_Plate_Required: 'LicensePlateRequired',
      Any_Destination_Required: 'DestinationRequired',
      Any_Reason_Required: 'ReasonRequired',
      Any_Require_End_Time: 'AnyRequireEndTime',
      Any_Supervisor_Approval: 'SupervisorApproval',
      '15-Minute_Time_Entry': 'FifteenMinuteTimeEntry',
      Any_Show_Consumer_Signature: 'ShowConsumerSignature',
      Show_Consumer_Note: 'ShowConsumerNote',
      Any_Location_Services_Required: 'RequireLocationServices',
      Require_Time_Entry_Transportation_Times: 'RequireTransportationTimes',
      Undocumented_Services_Warning: 'UndocumentedServicesWarning',
      'Use_System_Time_for_Clock_In/Out': 'UseSystemTimeForClockInOut',
      Auto_Import_Time: 'AutoImportTime',
    };

    const checkboxesSingleEntry = {
      Any_Note_Required: 'Note Required',
      Any_Odometer_Required: 'Odometer Required',
      Any_License_Plate_Required: 'License Plate Required',
      Any_Destination_Required: 'Origination/Destination Required',
      Any_Reason_Required: 'Reason Required',
      Any_Require_End_Time: 'Require Prior Entry End Time',
      Any_Supervisor_Approval: 'Supervisor Approval',
      '15-Minute_Time_Entry': '15-Minute Time Entry',
      Any_Show_Consumer_Signature: 'Show Consumer Signature',
      Show_Consumer_Note: 'Show Consumer Note',
      Any_Location_Services_Required: 'Require Location Services',
    };

    const checkboxesTimeEntry = {
      Undocumented_Services_Warning: 'Undocumented Services Warning',
      'Use_System_Time_for_Clock_In/Out': 'Use System Time for Clock In/Out',
      Auto_Import_Time: 'Automatically Import Time',
    };

    const transportationTimesCheckbox = new Checkbox({
      label: 'Require Transportation Times',
      id: 'Require_Time_Entry_Transportation_Times',
      'data-section': 'Anywhere',
      'data-key': 'Require_Time_Entry_Transportation_Times',
      'data-lookup-key': 'RequireTransportationTimes',
      'data-lookup-section': 'TimeEntry',
    });
    transportationTimesCheckbox.setValue(systemPreferencesData.TimeEntry['RequireTransportationTimes']);
    frag.append(transportationTimesCheckbox.rootElement);

    inputInstances.TimeEntry = {
      ['RequireTransportationTimes']: transportationTimesCheckbox,
    };

    Object.entries(checkboxesSingleEntry).forEach(([key, label]) => {
      const valueKey = keyToValueMap[key];

      const seCheckbox = new Checkbox({
        label: label,
        id: key,
        'data-section': 'Single-Entry',
        'data-key': key,
        'data-lookup-key': valueKey,
        'data-lookup-section': 'TimeEntry',
      });
      seCheckbox.setValue(systemPreferencesData.TimeEntry[valueKey]);
      frag.append(seCheckbox.rootElement);

      inputInstances.TimeEntry = {
        [valueKey]: seCheckbox,
      };
    });

    Object.entries(checkboxesTimeEntry).forEach(([key, label]) => {
      const valueKey = keyToValueMap[key];

      const teCheckbox = new Checkbox({
        label: label,
        id: key,
        'data-section': 'Anywhere_Time_Entry',
        'data-key': key,
        'data-lookup-key': valueKey,
        'data-lookup-section': 'TimeEntry',
      });
      teCheckbox.setValue(systemPreferencesData.TimeEntry[valueKey]);
      frag.append(teCheckbox.rootElement);

      inputInstances.TimeEntry = {
        [valueKey]: teCheckbox,
      };
    });

    return frag;
  }
  function getTransportationView() {
    const frag = document.createDocumentFragment();

    const showBillableCheckbox = new Checkbox({
      label: 'Show Billable Checkbox',
      id: 'ShowBillableCheckbox',
      'data-section': 'Anywhere_Transportation',
      'data-key': 'Billable_Checkbox',
      'data-lookup-key': 'ShowBillableCheckbox',
      'data-lookup-section': 'Transportation',
    });
    showBillableCheckbox.setValue(systemPreferencesData.Transportation.ShowBillableCheckbox);
    frag.append(showBillableCheckbox.rootElement);

    inputInstances.Transportation = {
      ShowBillableCheckbox: showBillableCheckbox,
    };

    return frag;
  }
  function getWorkshopView() {
    const frag = document.createDocumentFragment();

    const autoInsertEntryCheckbox = new Checkbox({
      label: 'Auto-insert entry for absent record',
      id: 'AutoInsertEntryForAbsentRecord',
      'data-section': 'Anywhere Workshop',
      'data-key': 'Auto-Insert_Entry_for_Absent_Record',
      'data-lookup-key': 'AutoInsertEntryForAbsentRecord',
      'data-lookup-section': 'Workshop',
    });
    const startTimeInput = new Input({
      label: 'Default Start Time',
      id: 'DefaultStartTime',
      'data-section': 'Workshop',
      'data-key': 'Default_Start_Time',
      'data-lookup-key': 'DefaultStartTime',
      'data-lookup-section': 'Workshop',
      type: 'time',
    });
    const endTimeInput = new Input({
      label: 'Default End Time',
      id: 'DefaultEndTime',
      'data-section': 'Workshop',
      'data-key': 'Default_End_Time',
      'data-lookup-key': 'DefaultEndTime',
      'data-lookup-section': 'Workshop',
      type: 'time',
    });

    autoInsertEntryCheckbox.setValue(systemPreferencesData.Workshop.AutoInsertEntryForAbsentRecord);
    startTimeInput.setValue(systemPreferencesData.Workshop.DefaultStartTime);
    endTimeInput.setValue(systemPreferencesData.Workshop.DefaultEndTime);

    frag.append(autoInsertEntryCheckbox.rootElement);
    frag.append(startTimeInput.rootElement);
    frag.append(endTimeInput.rootElement);

    inputInstances.Workshop = {
      AutoInsertEntryForAbsentRecord: autoInsertEntryCheckbox,
      DefaultStartTime: startTimeInput,
      DefaultEndTime: endTimeInput,
    };

    autoInsertEntryCheckbox.onChange(e => {
      if (e.target.checked) {
        startTimeInput.toggleDisabled(false);
        endTimeInput.toggleDisabled(false);

        return;
      }

      startTimeInput.toggleDisabled(true);
      endTimeInput.toggleDisabled(true);
    });

    if (!systemPreferencesData.Workshop.AutoInsertEntryForAbsentRecord) {
      startTimeInput.toggleDisabled(true);
      endTimeInput.toggleDisabled(true);
    }

    return frag;
  }

  async function handleOnChange(e) {
    const target = e.target;
    const section = target.dataset.section;
    const settingKey = target.dataset.key;
    const lookupKey = target.dataset.lookupKey;
    const lookupSection = target.dataset.lookupSection;

    if (!section || !settingKey) return;

    // console.log('Updating Sys Pref:', section, settingKey);

    try {
      const resp = await _UTIL.fetchData('updateSystemPreference', {
        section: section.replaceAll('_', ' '),
        key: settingKey.replaceAll('_', ' '),
        value: target.type === 'checkbox' ? target.checked : target.value,
      });

      if (section !== Setup.Plan) {
        systemPreferencesData[lookupSection][lookupKey] = target.type === 'checkbox' ? target.checked : target.value;
      }
    } catch (error) {
      inputInstances[lookupSection][lookupKey].showError('Error updating system preference');
      console.error('Error updating system preference:', error);
    }
  }

  function getView(viewName) {
    const viewFragment = document.createDocumentFragment();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = `${viewName} System Preferences`;

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    if (!$.session.SetupUpdate) {
      viewBody.classList.add('disabledSetupPage');
      viewBody.addEventListener('keydown', e => {
        if (e.code === 'Space') {
          e.preventDefault();
        }
      });
    } else {
      viewBody.addEventListener('change', handleOnChange);
    }

    let viewMarkup;

    switch (viewName) {
      case Setup.CASE_NOTES: {
        viewMarkup = getCaseNotesView();
        break;
      }
      case Setup.DAY_SERVICES: {
        viewMarkup = getDayServicesView();
        break;
      }
      case Setup.GENERAL: {
        viewMarkup = getGeneralView();
        break;
      }
      case Setup.INCIDENT_TRACKING: {
        viewMarkup = getIncidentTrackingView();
        break;
      }
      case Setup.LOGIN_LOGOUT: {
        viewMarkup = getLoginLogoutView();
        break;
      }
      case Setup.PLAN: {
        viewMarkup = getPlanView();
        break;
      }
      case Setup.ROSTER: {
        viewMarkup = getRosterView();
        break;
      }
      case Setup.SCHEDULING: {
        viewMarkup = getSchedulingView();
        break;
      }
      case Setup.TIME_ENTRY: {
        viewMarkup = getTimeEntryView();
        break;
      }
      case Setup.TRANSPORTATION: {
        viewMarkup = getTransportationView();
        break;
      }
      case Setup.WORKSHOP: {
        viewMarkup = getWorkshopView();
        break;
      }
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  async function init(data) {
    inputInstances = {};

    if ($.session.flag.moneymanagementSysPref) {
      systemPreferencesData = data;
    } else {
      const resp = await _UTIL.fetchData('getAllSystemPreferences', {
        token: $.session.Token,
        userId: $.session.UserId,
      });

      systemPreferencesData = resp.getAllSystemPreferencesResult;
    }
  }

  return {
    init,
    getView,
  };
})();
